import { render, staticRenderFns } from "./TodoEdit.vue?vue&type=template&id=608116af"
import script from "./TodoEdit.vue?vue&type=script&lang=js"
export * from "./TodoEdit.vue?vue&type=script&lang=js"
import style0 from "./TodoEdit.vue?vue&type=style&index=0&id=608116af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports